import { DPoPAPIService } from './dpop';

const baseURL = process.env.REACT_APP_API_URL;
export const apiService = new DPoPAPIService(baseURL, true);

export const initPromise = apiService.initialize();
